/*
 * @Author: weiyanna
 * @Date: 2021-12-28 09:29:01
 * @LastEditTime: 2022-08-22 13:52:55
 * @LastEditors: weiyanna weiyanna@jd.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /isp_pro/src/util/common.js
 */

import { getCustomerServiceToken } from '@/api/newApi/header';
import { message } from 'antd';

//字符串截取
const cutString = (string, long = 10) => {
  if (!string || typeof string !== 'string') {
    return '';
  }
  return string.length > long ? `${string.slice(0, long)}...` : string;
};

//设置字符串脱敏

const hideKeyWords = (string, type = 'invoice') => {
  switch (type) {
    case 'invoice':
      return string && string.length > 10 ? string.slice(0, 6) + '******' + string.slice(-4) : string;
    case 'mobile':
      return string && string.length === 1 ? string.slice(0, 3) + '******' + string.slice(-4) : string;
    default:
      return string;
  }
};

// 当前显示新旧版本按钮名称
const showHomeVersionButtonStr = pin => {
  try {
    const url = window.location.pathname.split('/').indexOf('newHome') > -1;
    const local = window.localStorage.getItem('HOMEVERSION');

    const result = url ? (url ? '返回旧版' : '前往新版') : local && local[pin] === 'NEW' ? '返回旧版' : '前往新版';

    return result;
  } catch (e) {
    window.localStorage.setItem('HOMEVERSION', JSON.stringify({}));
  }
};

let isFetchingToken = false;
const openCustomerServiceChat = async () => {
  if (isFetchingToken) {
    return;
  }
  isFetchingToken = true;
  try {
    const res = await getCustomerServiceToken();
    if (res.success && res.value) {
      const { nonce, loginToken } = res.value;
      const lang = localStorage.getItem('_language');
      const userLang = ['zh', 'en', 'th'].includes(lang) ? lang : 'en';
      const url = `https://jdcs.jd.com/?entry=jd_web_gygjzxkf&customerAppId=jdgygj.customer&venderId=1&token=${loginToken}&nonce=${nonce}&lang=${userLang}&forceHideList=true&rightMenu=1`;
      window.open(url);
    }
  } catch (error) {
    message.error(window.TLT('客服获取失败'));
    console.error('Failed to open customer service chat:', error);
  } finally {
    isFetchingToken = false;
  }
};

export { cutString, hideKeyWords, showHomeVersionButtonStr, openCustomerServiceChat };
